import { Api } from '@/api/api';
import { Address } from '@/shared/address';

export class AddressLookupApi extends Api {
    public async getByPostcodeAsync(postcode: string): Promise<Array<Address>> {
        return await this.getAsync<Array<Address>>(`v1/address/${postcode}`);
    }

    public constructor() {
        super();
    }
}
